module.exports = __webpack_public_path__ + "static/media/0.dc008997.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/nose/0.png
// module id = 858
// module chunks = 0